import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';

@JsonObject('model.cv.CvMaterial')
export class CvMaterial extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(Number, 'reservedQuantity')
    reservedQuantity: number;

    @JsonProperty(String, 'typeName')
    typeName: string;

}
